// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicLayout from './components/PublicLayout';
import AdminLayout from './components/admin/AdminLayout';

// Public Sayfalar
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import Hakkimizda from './pages/Hakkimizda';

// Admin Sayfalar
import AdminLogin from './pages/admin/AdminLogin';
import AdminHome from './pages/admin/AdminHome';
import AdminProductTypes from './pages/admin/AdminProductTypes';
import AdminProductTypeForm from './pages/admin/AdminProductTypeForm';
import AdminProductSubTypes from './pages/admin/AdminProductSubTypes';
import AdminProductSubTypeForm from './pages/admin/AdminProductSubTypeForm';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductForm from './pages/admin/AdminProductForm';

// Admin Araç Sayfaları
import AdminVehicleBrands from './pages/admin/AdminVehicleBrands';
import AdminVehicleBrandForm from './pages/admin/AdminVehicleBrandForm';
import AdminVehicleModels from './pages/admin/AdminVehicleModels';
import AdminVehicleModelForm from './pages/admin/AdminVehicleModelForm';
import AdminVehicleSeries from './pages/admin/AdminVehicleSeries';
import AdminVehicleSeriesForm from './pages/admin/AdminVehicleSeriesForm';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Sayfalar */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/urunler" element={<ProductList />} />
          <Route path="/products" element={<ProductList />} />
          {/* Yeni: slug tabanlı ürün detay */}
          <Route path="/urun/:slug" element={<ProductDetail />} />
          {/* Geriye dönük uyumluluk: eski format */}
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/about" element={<Hakkimizda />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Admin Login */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Navigate to="/admin/home" replace />} />

        {/* Admin Sayfaları */}
        <Route element={<AdminLayout />}>
          <Route path="/admin/home" element={<AdminHome />} />

          {/* Kategori Yönetimi */}
          <Route path="/admin/producttypes" element={<AdminProductTypes />} />
          <Route path="/admin/producttypes/new" element={<AdminProductTypeForm />} />
          <Route path="/admin/producttypes/edit/:id" element={<AdminProductTypeForm />} />
          <Route path="/admin/productsubtypes" element={<AdminProductSubTypes />} />
          <Route path="/admin/productsubtypes/new" element={<AdminProductSubTypeForm />} />
          <Route path="/admin/productsubtypes/edit/:id" element={<AdminProductSubTypeForm />} />

          {/* Ürün Yönetimi */}
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/products/new" element={<AdminProductForm />} />
          <Route path="/admin/products/edit/:id" element={<AdminProductForm />} />

          {/* Araç Yönetimi */}
          <Route path="/admin/vehicles/brands" element={<AdminVehicleBrands />} />
          <Route path="/admin/vehicles/brands/new" element={<AdminVehicleBrandForm />} />
          <Route path="/admin/vehicles/brands/edit/:id" element={<AdminVehicleBrandForm />} />
          <Route path="/admin/vehicles/models" element={<AdminVehicleModels />} />
          <Route path="/admin/vehicles/models/new" element={<AdminVehicleModelForm />} />
          <Route path="/admin/vehicles/models/edit/:id" element={<AdminVehicleModelForm />} />
          <Route path="/admin/vehicles/series" element={<AdminVehicleSeries />} />
          <Route path="/admin/vehicles/series/new" element={<AdminVehicleSeriesForm />} />
          <Route path="/admin/vehicles/series/edit/:id" element={<AdminVehicleSeriesForm />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
